<template>
  <ul class="cancel_feature_list">
    <li v-for="feature in shuffledFeatures">{{ feature }}</li>
  </ul>
</template>

<script>
export default {
  name: "CancelFeatureList",
  // Todo change the order of the list
  data() {
    return {
      features: [
        'Automated text and email sequences will stop following up with your leads',
        'Your notes, history and records for all your contacts and seller leads will be deleted',
        'Historical KPI\'s & Scorecard Reporting data is lost and erased',
        'Comps and property data information is no longer available',
        'Lose access to Property Owner Name & Mailing Address ',
        'Deal Pipeline and Status automations disappear',
        'Lose access to Hot Motivators Tool',
        '3rd Party Integrations will be removed/deleted',
        'Marketing campaign tracking and cost reporting data will be lost',
      ]
    }
  },
  computed: {
    shuffledFeatures() {
      const array = this.features
      let currentIndex = array.length, randomIndex;

      // While there remain elements to shuffle.
      while (currentIndex != 0) {

        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex], array[currentIndex]];
      }

      return array;
    },
  }
}
</script>

<style lang="scss" scoped>
.cancel_feature_list {
  margin-top: 10px;
  padding-left: 1rem;
  list-style: disc;

  li {
    margin-bottom: 6px;
    font-size: 0.875rem;
    line-height: 1.3;
  }
}
</style>
